module.exports = __webpack_public_path__ + "static/media/global.1302408a.svg";